/**
 * Graph algorithms for analyzing the artist similarity network
 */

/**
 * Compute play rank for all nodes in the graph
 * This is a variation of PageRank that considers both play count and similarity connections
 *
 * @param {Object} graph - The graph instance
 * @param {Object} state - Application state (for maxPlaycount)
 */
export function computePlayRank(graph, state) {
  // Initialize nodes based on playcount
  graph.forEachNode((node) => {
    node.data.playRank = (node.data.playcount || 0) / state.maxPlaycount;
    node.data.degree = 0;
    node.data.matchSum = 0;
  });

  // Calculate degree and match sum for each node
  graph.forEachNode((node) => {
    graph.forEachLinkedNode(node.id, (linkedNode, link) => {
      node.data.degree += 1;
      node.data.matchSum += link.data.match || 0;
    });
  });

  // Run PageRank-style iterations
  const damping = 0.85;
  const iterations = 5;

  for (let i = 0; i < iterations; i += 1) {
    graph.forEachNode((node) => {
      let incoming = 0;
      graph.forEachLinkedNode(node.id, (linkedNode, link) => {
        incoming +=
          linkedNode.data.playRank *
          (link.data.match / linkedNode.data.matchSum);
      });
      node.data.playRank += incoming * damping;
    });
  }

  // Update maxPlayRank in state
  state.maxPlayRank = 0.00001;
  graph.forEachNode((node) => {
    state.maxPlayRank = Math.max(state.maxPlayRank, node.data.playRank || 0);
  });

  console.log(`maxPlayRank = ${state.maxPlayRank}`);
}

/**
 * Get top unlistened artists based on play rank
 * These are artists with 0 playcount but high similarity to listened artists
 *
 * @param {Array} artists - Array of all artists
 * @param {number} limit - Number of artists to return
 * @returns {Array} Top unlistened artists sorted by play rank
 */
export function getTopUnlistenedArtists(artists, limit = 10) {
  return artists
    .filter((a) => a.playcount === 0)
    .sort((a, b) => {
      return (b.playRank || 0) - (a.playRank || 0);
    })
    .slice(0, limit);
}
